import { API_EXTERNAL_PRESENCES } from './apiConst';
import axios from 'axios';

export const getClassroomPresence = (classroomId, schoolId) => {
  const presenceUrl = `${API_EXTERNAL_PRESENCES}?platform=classroom&tenantId=${schoolId}&sectionId=${classroomId}`;
  return axios.get(presenceUrl);
};
